import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
	HttpService,
	GET,
	Adapter,
	POST,
	Body
} from "@royalty/httpclient";

@Injectable()
export class ReasonService extends HttpService {
	@GET("voidreason/reasons")
	@Adapter(null, { isAdmin: false })
	getReasons(): Observable<any> {
		return null;
	}

	@POST("voidreason/create")
	@Adapter(null, { isAdmin: false })
	createReason(@Body data: string): Observable<any> {
		return null;
	}
}
